export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'La prochaine date de commande ne peut pas être modifiée',
  rebillInProgress:
    'La prochaine date de commande ne peut pas être modifiée : refacturation en cours',
  paymentFailed: 'La prochaine date de commande ne peut pas être modifiée : paiement échoué'
};
